import React from 'react';
import PropTypes from 'prop-types';
import ProjectDetail from '../../common/ProjectDetail';
var renderDraftStatus = function renderDraftStatus(requiredFieldsCount) {
  if (requiredFieldsCount > 0) {
    return /*#__PURE__*/React.createElement("div", null, "Complete ".concat(requiredFieldsCount, " required field").concat(requiredFieldsCount !== 1 ? 's' : '', " to submit your project post!"), /*#__PURE__*/React.createElement("i", {
      className: "fa fa-running ms-2"
    }));
  }
  return /*#__PURE__*/React.createElement("div", null, "Submit your project to Clora for review");
};
var renderOpenStatus = function renderOpenStatus(state, candidatesNeedReview, projectType, invitationCount, proposalRequestConsultant) {
  var status = 'Hired';
  var icon = 'handshake';
  var label = null;
  if (state === 'employer_requested_matching') {
    if (projectType === 'open_marketplace') {
      status = 'Invitations';
      icon = 'search';
      label = 'Connect and receive proposals';
    } else if (projectType === 'request') {
      status = 'Requested: Hire Again';
      icon = 'hourglass';
      label = "Waiting for ".concat(proposalRequestConsultant, "\u2019s answer");
    } else {
      status = 'Under review';
      icon = 'hourglass';
    }
  } else if (state === 'clora_matching' && candidatesNeedReview) {
    status = 'Review candidates';
    icon = 'users';
  } else if (state === 'clora_matching') {
    status = 'Vetting candidates';
    icon = 'filter';
  } else if (state === 'work_started') {
    status = 'Work started';
    icon = 'microscope';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "body-text-3 demibold g-row--always open-status ".concat(label ? 'requires_more_attention' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "circle-icon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-column g-column--centered"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-".concat(icon)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "g-column ".concat(state, " ").concat(candidatesNeedReview ? 'candidates-needs-review' : '')
  }, /*#__PURE__*/React.createElement("div", null, invitationCount && projectType === 'open_marketplace' ? "(".concat(invitationCount, ") ").concat(status) : status, label ? /*#__PURE__*/React.createElement("div", {
    className: "body-text-3 normal-weight"
  }, label) : /*#__PURE__*/React.createElement("div", {
    className: "g-row--always tracking-bars"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bar bar-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bar bar-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bar bar-3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bar bar-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bar bar-5"
  })))));
};
var renderClosedStatus = function renderClosedStatus(state) {
  var status = 'Work completed';
  var icon = 'clipboard-check';
  if (state === 'on_hold') {
    status = 'On hold';
    icon = 'pause';
  } else if (state === 'closed') {
    status = 'Closed';
    icon = 'times';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "body-text-3 demibold g-row--always closed-status ".concat(state)
  }, /*#__PURE__*/React.createElement("div", {
    className: "circle-icon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-column g-column--centered"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-".concat(icon)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "g-column g-column--centered"
  }, status));
};
function EmployerProjectCard(props) {
  var project = props.project,
    status = props.status,
    showProjectEmploymentType = props.showProjectEmploymentType;
  var ctaText = 'View Project';
  var ctaLink = project.project_link;
  if (project.draft) {
    ctaText = 'Finish Draft';
    ctaLink = project.edit_project_link;
  } else if (project.proposals_need_attention) {
    ctaText = "View Proposal".concat(project.proposals_count > 1 ? 's' : '');
  } else if (project.reviewable) {
    ctaText = "Review ".concat(project.accepted_consultant_initials);
    ctaLink = project.review_link;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "card box-shadow-1 project-".concat(project.resource_id, " mb-3 border-0")
  }, /*#__PURE__*/React.createElement(ProjectDetail, {
    key: "project-".concat(project.resource_id),
    className: status,
    name: project.name,
    workCommitment: project.lowest_time_per_week,
    workCommitmentText: project.avg_time_required_text,
    tags: project.tags,
    duration: project.duration_range,
    durationText: project.duration_text,
    workLocation: project.work_location,
    employmentType: project.employment_type,
    showProjectEmploymentType: showProjectEmploymentType
  }), /*#__PURE__*/React.createElement("div", {
    className: "cta-container mt-4 g-row-justify-right g-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pe-3 g-row--always cta ".concat(status)
  }, status === 'open' && renderOpenStatus(project.status, project.proposals_need_attention, project.project_type, project.project_invitations, project.proposal_request_consultant), status === 'closed' && renderClosedStatus(project.status), /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight g-column g-column--centered cta-alert"
  }, status === 'draft' && renderDraftStatus(project.required_fields_count), project.proposals_need_attention && "".concat(project.proposals_count, " proposal").concat(project.proposals_count !== 1 ? 's' : ''))), project.reviewable && /*#__PURE__*/React.createElement("a", {
    href: "projects/".concat(project.resource_id),
    "data-status": project.status,
    className: "employer-project-show btn btn-secondary-no-border"
  }, "View Project"), /*#__PURE__*/React.createElement("a", {
    href: ctaLink,
    "data-status": project.status,
    className: "".concat(project.reviewable ? 'project-dashboard-review-consultant-btn' : 'employer-project-show', " btn btn-").concat(project.expired ? 'default' : 'primary')
  }, ctaText)));
}
EmployerProjectCard.propTypes = {
  project: PropTypes.shape({}).isRequired,
  status: PropTypes.string.isRequired,
  showProjectEmploymentType: PropTypes.bool
};
EmployerProjectCard.defaultProps = {
  showProjectEmploymentType: false
};
export default EmployerProjectCard;